/* properties */
export const PROJECT_DETAILS_PROPERTIES_ACTIVATE = 'PROJECT_DETAILS_PROPERTIES_ACTIVATE';
export const PROJECT_DETAILS_PROPERTIES_DEACTIVATE = 'PROJECT_DETAILS_PROPERTIES_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/actions/properties.ts